import React from "react";
import "../styles/heroStyles.css";
import Image1 from "../assets/maan_industries_2.png";


const Hero = () => {
  return (
   <div className="hero">
      <div className="hero-left">
        <img src={Image1} alt="Maan Industries" className="hero-image" />
      </div>
      <div className="hero-right">
        <p><span style={{color:"#000", fontWeight:"600", fontSize:"22px"}}>
          Maan Masterbatches</span>  is a forward-thinking manufacturer specializing in high-quality masterbatches 
          for the plastics industry. Founded in 2021, our company is driven by a mission to deliver consistent performance, 
          innovative formulations, and unmatched service to plastic processors across India. </p>
        </div>
    </div>
  );
};

export default Hero;
